import * as colors from './colors';

export const HELVETICA_NEUE_BOLD = 'HelveticaNeue-Bold';
export const HELVETICA_NEUE_CONDENSED_BOLD = 'HelveticaNeue-CondensedBold';
export const HELVETICA_NEUE_MEDIUM = 'HelveticaNeue-Medium';
export const HELVETICA_NEUE = 'HelveticaNeue';
export const HELVETICA_REGULAR = 'HelveticaNeue';
export const GEORGIA = 'Georgia';

export const HelveticaNeueBold = `font-family: '${HELVETICA_NEUE_BOLD}';`;
export const HelveticaNeueCondensedBold = `font-family: '${HELVETICA_NEUE_CONDENSED_BOLD}';`;
export const HelveticaNeueMedium = `font-family: '${HELVETICA_NEUE_MEDIUM}';`;
export const HelveticaNeue = `font-family: '${HELVETICA_NEUE}';`;
export const Georgia = `font-family: '${GEORGIA}';`;

export const lh = 1.5;

export const bodyStyle = {
  fontSize: 2,
  lineHeight: 2,
  fontFamily: HELVETICA_REGULAR,
  color: colors.black,
};

export const header = {
  fontSize: 3,
  lineHeight: 3,
  fontFamily: HELVETICA_NEUE_BOLD,
  color: colors.black,
};

export const highlight = {
  fontSize: 3,
  lineHeight: 3,
  fontFamily: GEORGIA,
  fontStyle: 'italic',
  color: colors.black,
};

export const title = {
  // display: 'flex',
  fontSize: 2,
  lineHeight: 2,
  fontFamily: HELVETICA_NEUE_CONDENSED_BOLD,
  color: colors.black,
};

// REQUIRES FONT-INHERIT
export const numericalValue = {
  fontSize: 2,
  lineHeight: 2,
  fontFamily: HELVETICA_NEUE_CONDENSED_BOLD,
  color: colors.black,
};

export const link = {
  fontSize: 1,
  lineHeight: 1,
  fontFamily: HELVETICA_NEUE_MEDIUM,
  color: colors.grey,
  // padding: `${sizing(0.5)} 0`
};

export const altLink = {
  ...link,
  textDecorationLine: 'underline',
};

// export const bodyText = {
//   fontSize: sizing(1.5),
//   lineHeight: sizing(1.5 * lh),
//   fontFamily: HELVETICA_REGULAR,
//   color: colors.black
// };

export const commentText = {
  fontSize: 3,
  lineHeight: 3,
  fontFamily: GEORGIA,
  color: colors.black,
};

export const secondaryText = {
  fontSize: 1,
  lineHeight: 1,
  fontFamily: HELVETICA_REGULAR,
  color: colors.secondaryText,
};

export const communityLink = {
  fontSize: 2,
  lineHeight: 2,
  fontFamily: HELVETICA_REGULAR,
  color: colors.grey,
};

export const CTALink = {
  fontSize: 1,
  lineHeight: 1,
  fontFamily: HELVETICA_REGULAR,
  color: colors.blue,
};

// export const button = {
//   background: colors.blue,
//   color: colors.white,
//   display: 'flex',
//   alignItems: 'center',
//   border: 'none',
//   justifyContent: 'space-between',
//   height: sizing(16),
//   minWidth: sizing(18),
//   padding: `0  ${sizing(2)}`,
//   fontsize: sizing(1.5),
//   fontFamily: HELVETICA_NEUE_MEDIUM,
// };
